import { Grid } from '@mui/material'
import React from 'react'

import { CopyClipboardButton } from 'components/common/CopyClipboardButton'
import { TruncatedTextWithTooltip } from 'components/common/TruncatedTextWithTooltip'
import Icon, { type IconName } from 'components/Icon'
import { muiTheme } from 'mui-theme'

export const DrawerUserDetail: React.FC<{
  clipboardOptions?: {
    content: string
    tooltipText: string
  }
  iconName: IconName
  text: string
}> = ({ clipboardOptions, iconName, text }) => {
  return (
    <>
      <Grid item sx={{ textAlign: 'center' }} xs={2}>
        <Icon css={{ marginRight: muiTheme.spacing(0.5) }} icon={iconName} />
      </Grid>

      <Grid item zeroMinWidth xs={clipboardOptions ? 8 : 10}>
        <TruncatedTextWithTooltip tooltipProps={{ title: text }}>
          {text}
        </TruncatedTextWithTooltip>
      </Grid>

      {clipboardOptions?.content && (
        <Grid item sx={{ textAlign: 'center' }} xs={2}>
          <CopyClipboardButton
            content={clipboardOptions.content}
            tooltipText={clipboardOptions.tooltipText}
          />
        </Grid>
      )}
    </>
  )
}
